import { SECTIONS, SITE_NAME } from '@/data/sections';
import { CONTACT, MAILTO_URL, WHATSAPP_URL } from '@/data/site';
import { hashForSection } from '@/hooks/useHashRoute';
import type { SectionId } from '@/types';
import styles from './Footer.module.css';

export interface FooterProps {
  readonly section: SectionId;
  readonly onNavigate: (section: SectionId) => void;
}

export function Footer({ section, onNavigate }: FooterProps) {
  return (
    <footer className={styles.footer}>
      <div className={styles.grid}>
        <div>
          <p className={styles.brandName}>{SITE_NAME}</p>
          <p className={styles.tagline}>منصة تعليمية مجانية لنشر الذكاء الاصطناعي في التعليم</p>
          <p className={styles.author}>{CONTACT.author}</p>
        </div>

        <nav aria-label="أقسام الموقع">
          <p className={styles.columnTitle}>أقسام الموقع</p>
          <div className={styles.links}>
            {SECTIONS.map((item) => (
              <a
                key={item.id}
                href={hashForSection(item.id)}
                className={styles.link}
                aria-current={item.id === section ? 'page' : undefined}
                onClick={(event) => {
                  event.preventDefault();
                  onNavigate(item.id);
                }}
              >
                {item.label}
              </a>
            ))}
          </div>
        </nav>

        <div>
          <p className={styles.columnTitle}>الدعم</p>
          <address className={styles.support}>
            <a className={styles.ltr} href={MAILTO_URL}>
              {CONTACT.email}
            </a>
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">
              رقم الدعم: {CONTACT.phone}
            </a>
            <span>{CONTACT.location}</span>
          </address>
        </div>
      </div>

      <div className={styles.bottom}>
        <p className={styles.bottomInner}>
          © {new Date().getFullYear()} {SITE_NAME} | {CONTACT.author}
        </p>
      </div>
    </footer>
  );
}
